module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-reports-form table wh100 table-w-0-100\">\n	<div>\n		<div class=\"gl-admin-form__menu\">\n			<div class=\"cell__abs_container\">\n				<div class=\"cell__abs overflow-y__auto\">\n					<div name=\"menu\"></div>\n				</div>\n			</div>\n		</div>\n\n		<div>\n			<div class=\"cell__abs_container\">\n				<div class=\"cell__abs\" name=\"section\">\n				</div>\n			</div>\n		</div>\n\n		<div name=\"recent\" class=\"recent\">\n			<div class=\"header\"><b>Последние отчеты</b></div>\n\n			<div class=\"cell__abs_container\">\n				<div class=\"cell__abs overflow-y__auto\">\n                    <div name=\"report-items\" style=\"max-height: 100%; padding-bottom: 20px; overflow-y: auto; overflow-x: hidden\"></div>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n")
  }
  return __output.join("");

}